import { NGET, NPOST } from '@/utils/net-work'

const baseUri = '/api'
/**
 * 1.获取确认教材信息
 */
function getConfirmBooks(params: { subject: string; level?: number, term?: number }) {
    return NGET('/book/sortbook.vpage', params)
}
/**
 * 2.获取题目列表
 */
function questionList(params: any, token?) {
    return NPOST(baseUri + '/question/list', params, token || '')
}

export {
    getConfirmBooks,
    questionList
}